import { TradeRestriction } from "@models/trading/tradeRestriction";
import { TradingRepo } from "@services/trading.repo";
import { TradePortfolio } from "@models/trading/tradePortfolio";
import { AuthService } from "@common/auth.service";
import { IPromise, IHttpResponse } from "angular";
import { Roles } from "@common/enums/Roles";
import { AssetClassNameArray } from "@common/enums/AssetClassType";
import { extractErrorMessage } from "@common/utils/errorUtils";

class EditTradeRestrictionController {
  public isLoading = false;
  public canEnable = false;
  public tradePortfolio: TradePortfolio;
  public securities: Array<any>;
  public allAssetClasses: Array<any>;
  public newTradeRestriction: boolean;
  public securityTypeRestriction: boolean;
  public tradeRestriction: TradeRestriction;
  public showDeleteTradeRestrictionOption: boolean;
  public securityFilter: string;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private tradingRepo: TradingRepo,
    private notifyjs: any,
    private authService: AuthService
  ) {}

  $onInit() {
    this.tradeRestriction.enabled = true;
    this.showDeleteTradeRestrictionOption = false;
    this.canEnable =
      this.authService.getUserRoles().indexOf(Roles.SeniorManagement) > -1 ||
      this.authService.getUserRoles().indexOf(Roles.SystemAdministrator) > -1;
    this.allAssetClasses = AssetClassNameArray;

    //filter out securities already added
    this.tradePortfolio.tradingRestrictions.forEach((tr) => {
      //if not active - don't filter at all
      if (tr.enabled == true) {
        //security type
        if (tr.assetClass == null) {
          this.securities = this.securities.filter(
            (s) => s.id !== tr.security.id
          );
        }
        //assetclass type
        else {
          this.securities = this.securities.filter(
            (s) => s.assetClass.name !== tr.assetClass.name
          );
        }
      }
    });
  }

  saveTradeRestriction() {
    this.isLoading = true;

    this.tradeRestriction.portfolio = {};
    this.tradeRestriction.portfolio.portfolioId = this.tradePortfolio.id;

    let savePromise: IPromise<IHttpResponse<{}>>;
    if (this.newTradeRestriction) {
      savePromise = this.tradingRepo.addPortfolioTradeRestriction(
        this.tradePortfolio.id,
        this.tradeRestriction
      );
    } else {
      savePromise = this.tradingRepo.updatePortfolioTradeRestriction(
        this.tradePortfolio.id,
        this.tradeRestriction
      );
    }

    savePromise
      // .then(res => { }) // Old code wasnt used
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => {
        this.isLoading = false;
        this.$mdDialog.hide(this.tradeRestriction);
      });
  }

  displayDeleteTradeRestrictionOption() {
    this.showDeleteTradeRestrictionOption = true;
  }

  hideDeleteTradeRestrictionOption() {
    this.showDeleteTradeRestrictionOption = false;
  }

  deleteAssetClassTypeTradeRestriction() {
    this.isLoading = true;

    this.tradeRestriction.portfolio = {};
    this.tradeRestriction.portfolio.portfolioId = this.tradePortfolio.id;

    let deleteAssetClassTypePromise: IPromise<IHttpResponse<{}>>;
    deleteAssetClassTypePromise =
      this.tradingRepo.deleteAssetClassTypeTradeRestriction(
        this.tradePortfolio.id,
        this.tradeRestriction
      );

    deleteAssetClassTypePromise
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => {
        this.isLoading = false;
        this.$mdDialog.hide(this.tradeRestriction);
      });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

export const editTradeRestrictionModal: angular.IComponentOptions = {
  template: require("./editTradeRestriction.modal.html"),
  controller: EditTradeRestrictionController,
  bindings: {
    tradePortfolio: "<",
    securities: "<",
    newTradeRestriction: "<",
    tradeRestriction: "<",
    securityTypeRestriction: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/portfolio/modals/editTradeRestriction.modal.ts